<div class="expert-mode-container">
  <!-- Toolbar -->
  <div class="toolbar">
    <div class="toolbar-left">
      <h3 class="mode-title">
        <nz-icon nzType="code" nzTheme="outline"></nz-icon>
        {{ 'builderScreen.expertMode.title' | translateTA }}
      </h3>
    </div>
    <div class="toolbar-right">
      <button nz-button nzSize="small" (click)="clearCode()" [nz-tooltip]="'builderScreen.expertMode.tooltip.clearCode' | translateTA">
        <nz-icon nzType="clear" nzTheme="outline"></nz-icon>
      </button>
    </div>
  </div>

  <!-- Editor de Código -->
  <div class="code-editor-section">
    <textarea
      nz-input
      [(ngModel)]="code"
      (ngModelChange)="onCodeChange()"
      [nzAutosize]="{ minRows: 15, maxRows: 25 }"
      [placeholder]="'builderScreen.expertMode.placeholder.code' | translateTA"
      class="code-textarea">
    </textarea>
  </div>

  <!-- Validação -->
  <div class="validation-section" *ngIf="validationErrors.length > 0 || validationWarnings.length > 0">
    <nz-alert
      *ngFor="let error of validationErrors"
      nzType="error"
      [nzMessage]="error"
      nzShowIcon
      class="validation-alert">
    </nz-alert>

    <nz-alert
      *ngFor="let warning of validationWarnings"
      nzType="warning"
      [nzMessage]="warning"
      nzShowIcon
      class="validation-alert">
    </nz-alert>
  </div>

  <!-- API Reference -->
  <div class="api-reference-section">
    <nz-collapse>
      <nz-collapse-panel
        [nzHeader]="'builderScreen.expertMode.apiReference.title' | translateTA"
        [nzActive]="false">
        <div class="api-content">
          <h4>{{ 'builderScreen.expertMode.apiReference.context' | translateTA }}</h4>
          <ul>
            <li><code>{{ 'builderScreen.expertMode.apiReference.contextCurrentValue' | translateTA }}</code></li>
            <li><code>{{ 'builderScreen.expertMode.apiReference.contextPreviousValue' | translateTA }}</code></li>
            <li><code>{{ 'builderScreen.expertMode.apiReference.contextComponentId' | translateTA }}</code></li>
            <li><code>{{ 'builderScreen.expertMode.apiReference.contextFormData' | translateTA }}</code></li>
          </ul>

          <h4>{{ 'builderScreen.expertMode.apiReference.tabsApi' | translateTA }}</h4>
          <ul>
            <li><code>{{ 'builderScreen.expertMode.apiReference.showTab' | translateTA }}</code></li>
            <li><code>{{ 'builderScreen.expertMode.apiReference.hideTab' | translateTA }}</code></li>
            <li><code>{{ 'builderScreen.expertMode.apiReference.enableTab' | translateTA }}</code></li>
            <li><code>{{ 'builderScreen.expertMode.apiReference.disableTab' | translateTA }}</code></li>
          </ul>

          <h4>{{ 'builderScreen.expertMode.apiReference.componentsApi' | translateTA }}</h4>
          <ul>
            <li><code>{{ 'builderScreen.expertMode.apiReference.getComponent' | translateTA }}</code></li>
            <li><code>{{ 'builderScreen.expertMode.apiReference.setValue' | translateTA }}</code></li>
            <li><code>{{ 'builderScreen.expertMode.apiReference.getValue' | translateTA }}</code></li>
            <li><code>{{ 'builderScreen.expertMode.apiReference.getFormData' | translateTA }}</code></li>
          </ul>
        </div>
      </nz-collapse-panel>

      <nz-collapse-panel
        [nzHeader]="'builderScreen.expertMode.examples.title' | translateTA"
        [nzActive]="false">
        <div class="examples-content">
          <nz-card
            *ngFor="let example of codeExamples"
            class="example-card"
            [nzTitle]="example.name"
            [nzExtra]="applyBtn"
            nzSize="small">
            <pre class="example-code">{{ example.code }}</pre>
            <ng-template #applyBtn>
              <button
                nz-button
                nzType="link"
                nzSize="small"
                (click)="applyExample(example)">
                {{ 'builderScreen.expertMode.examples.useExample' | translateTA }}
              </button>
            </ng-template>
          </nz-card>
        </div>
      </nz-collapse-panel>
    </nz-collapse>
  </div>

  <!-- Nota sobre Monaco Editor -->
  <nz-alert
    nzType="info"
    [nzMessage]="'builderScreen.expertMode.alert.tip' | translateTA"
    [nzDescription]="'builderScreen.expertMode.alert.description' | translateTA"
    [nzCloseable]="true"
    class="monaco-note">
  </nz-alert>
</div>



